if (!customElements.get('cart-attach-carousel')) {
  class CartAttachCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cart-attach__row');
      this.slides = Array.from(this.querySelectorAll('[data-cart-attach-slide]'));
      this.previousButton = this.querySelector('[data-cart-attach-previous]');
      this.nextButton = this.querySelector('[data-cart-attach-next]');
      this.counter = this.querySelector('[data-cart-attach-counter]');
      this.variantSelectors = Array.from(this.querySelectorAll('[data-cart-attach-variant]'));
      this.currentIndex = Math.max(
        0,
        this.slides.findIndex((slide) => slide.classList.contains('is-active'))
      );

      this.handlePrevious = () => this.show(this.currentIndex - 1);
      this.handleNext = () => this.show(this.currentIndex + 1);
      this.handleScroll = () => {
        window.cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = window.requestAnimationFrame(() => {
          if (!this.track || this.slides.length === 0) return;

          const nearestIndex = this.slides.reduce((nearest, slide, index) => {
            const currentDistance = Math.abs(this.getSlideOffset(slide) - this.track.scrollLeft);
            const nearestDistance = Math.abs(
              this.getSlideOffset(this.slides[nearest]) - this.track.scrollLeft
            );
            return currentDistance < nearestDistance ? index : nearest;
          }, 0);

          this.setActive(nearestIndex);
        });
      };
      this.handleVariantChange = (event) => {
        const option = event.target.selectedOptions[0];
        const slide = event.target.closest('[data-cart-attach-slide]');
        const price = slide?.querySelector('[data-cart-attach-price]');
        if (price && option?.dataset.price) price.textContent = option.dataset.price;
      };

      this.previousButton?.addEventListener('click', this.handlePrevious);
      this.nextButton?.addEventListener('click', this.handleNext);
      this.track?.addEventListener('scroll', this.handleScroll, { passive: true });
      this.variantSelectors.forEach((select) => select.addEventListener('change', this.handleVariantChange));

      this.slides.forEach((slide) => {
        slide.hidden = false;
        slide.setAttribute('aria-hidden', 'false');
      });
      this.setActive(this.currentIndex);
    }

    disconnectedCallback() {
      this.previousButton?.removeEventListener('click', this.handlePrevious);
      this.nextButton?.removeEventListener('click', this.handleNext);
      this.track?.removeEventListener('scroll', this.handleScroll);
      window.cancelAnimationFrame(this.scrollFrame);
      this.variantSelectors?.forEach((select) => select.removeEventListener('change', this.handleVariantChange));
    }

    getSlideOffset(slide) {
      if (!this.track || !slide) return 0;

      const trackRect = this.track.getBoundingClientRect();
      const slideRect = slide.getBoundingClientRect();
      return slideRect.left - trackRect.left + this.track.scrollLeft;
    }

    setActive(index) {
      if (this.slides.length === 0) return;

      this.currentIndex = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === this.currentIndex);
      });

      if (this.counter) {
        this.counter.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
      }
    }

    show(index) {
      if (!this.track || this.slides.length === 0) return;

      const nextIndex = (index + this.slides.length) % this.slides.length;
      const nextSlide = this.slides[nextIndex];
      this.setActive(nextIndex);

      this.track.scrollTo({
        left: this.getSlideOffset(nextSlide),
        behavior: 'smooth',
      });
    }
  }

  customElements.define('cart-attach-carousel', CartAttachCarousel);
}
